import { ScrollView, View } from 'react-native';
import { useJourney } from '../contexts/JourneyContext.js';
import MarkdownText from '../elements/MarkdownText.jsx';
import SmallButton from '../elements/SmallButton.jsx';
import styles from '../Styles.jsx';

export default function PanelInfo({ dismiss }) {
  const { serverData } = useJourney();
  
  const componentStyles = {
    creditsText: {
      textAlign: 'center',
      fontSize: 18,
    }
  }; 

  return (
    <View style={styles.panelFrame}>
      <ScrollView style={{flex: 1, padding: 20}}>
        <MarkdownText>{serverData.credits || ""}</MarkdownText>
      </ScrollView>

      <SmallButton
        onPress={dismiss}
        buttonStyle={styles.smallCloseButton}
        title="Done"
      />
    </View>
  );
}
